import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SecurityIcon } from '@/shared/assets/icons/security-icon';
import { Button } from '@/shared/components/ui/button/button';
import { IconContainer } from '@/shared/components/ui/icon-container/icon-container.styled';
import {
  Modal,
  ModalContainer,
} from '@/shared/components/ui/modal-controller/modal-controller.styled';
import { LanguageSwitcher } from '@/shared/features/language-switcher/language-switcher';
import { EnableMfa } from '@/shared/features/rbac/components/enable-mfa/enable-mfa';
import { TEnforceMfaContentProps } from '@/shared/features/rbac/components/enforce-mfa-warning/enforce-mfa-content.types';
import { ThemeSwitcher } from '@/shared/features/theme-switcher/components/theme-switcher';
import { logout } from '@/shared/redux/api/auth/auth-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const EnforceMfaContent: React.FC<TEnforceMfaContentProps> = ({
  display,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    await dispatch(logout());
  };

  if (!display) {
    return null;
  }

  return (
    <>
      <Stack
        direction="row"
        gap="1rem"
        position="fixed"
        top="1rem"
        right="1rem"
        zIndex={1400}
      >
        <ThemeSwitcher />
        <LanguageSwitcher />
      </Stack>
      <Modal open={true} disableEscapeKeyDown>
        <ModalContainer width="28rem">
          <Stack gap="2rem">
            <Stack gap="1.25rem" alignItems="center">
              <IconContainer>
                <SecurityIcon />
              </IconContainer>
              <Typography variant="h5" textAlign="center">
                {t('rbac:enforce_mfa_warning_title')}
              </Typography>
              <Typography variant="p5" textAlign="center" color="textSecondary">
                {t('rbac:enforce_mfa_warning_description')}
              </Typography>
            </Stack>
            <Stack direction="row" gap="0.75rem" width="100%">
              <Button
                variant="secondary"
                fullWidth
                size="large"
                onClick={handleLogout}
              >
                {t('ui:logout')}
              </Button>
              <EnableMfa
                trigger={
                  <Button size="large" fullWidth>
                    {t('rbac:enable_mfa')}
                  </Button>
                }
                appUrl={import.meta.env.VITE_APP_BACKOFFICE_NAME as string}
              />
            </Stack>
          </Stack>
        </ModalContainer>
      </Modal>
    </>
  );
};
